import styled, { keyframes, css } from 'styled-components';
import { FaCoins } from "react-icons/fa";


// Główny kontener aplikacji - responsive
export const AppContainer = styled.div`
 @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    position: absolute; /* ← POSITION FIXED! */
    top: 104px;
   left: 18vw;
    right: 0;
    bottom: 0;
    padding: 20px;
}
`;

// Desktop Grid Layout
export const DesktopLayout = styled.div`
 display: flex;
    flex-direction: column;
    

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    display: grid;
    grid-template-columns: 1fr 0.7fr; /* Form | Music Player */
    grid-template-rows: auto 1fr;
    grid-template-areas: 
      "header header"
      "form player";
   max-width: 1300px;
    height: 100%;
    
  }
        @media (min-width: 1400px) {
max-width: 68vw;
}
`;



// Główny kontener muzyczny - responsive
export const MusicContainer = styled.div`
  /* Mobile styles - zachowujemy obecne */
  @media (max-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    margin-top: 8vh;
    // background: linear-gradient(90deg,${({ theme }) => theme.color.background} 0%,${({ theme }) => theme.color.spotifyDarkGreen} 100%);
    border-radius: 20px;
    color: white;
  }

  /* Desktop styles - nowe */
  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    grid-area: form;
    // background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 15px;
    padding-right: 30px;
    color: white;
    height: fit-content;
     min-height: 600px;
  }
`;

// Tytuł responsive
export const DesktopTitle = styled.h2`
  color: ${({ theme }) => theme.color.tileTitle};
  font-size: 24px;
  margin-bottom: 25px;
  text-align: center;
  @media (min-width: 1059px) {
    margin-top: 0px;
  }
  @media (max-width: 1059px) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    margin: 0;
    background-color: ${({ theme }) => theme.color.spotifyBlack};
    z-index: 11;
  }
`;

// Stały obszar dla odtwarzacza muzyki
export const MusicPlayerArea = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    grid-area: player;
    min-height: 400px;

  }
  background: rgba(255, 255, 255, 0.05);
    border-radius: 15px;
    padding: 20px;
    border: 2px dashed rgba(255, 255, 255, 0.2);
    min-height: 700px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: rgba(255, 255, 255, 0.6);
    font-size: 18px;
    transition: all 0.3s ease;
    ${({ hasMusic }) => hasMusic && css`
      border: none;
      background: rgba(255, 255, 255, 0.1);
      justify-content: flex-start;
      align-items: stretch;
    `}
`;

const TokenCostDisplay = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  color: #FFFFFF;
  font-weight: 500;
  position: absolute;
  bottom: 12px;
  right: 15px;

  svg {
    margin-right: 5px;
    color: #FFD700;
  }
`;

const loadingSpinner = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const circleComplete = keyframes`
  0% {
    stroke-dasharray: 50, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 100, 200;
    stroke-dashoffset: -15;
  }
  100% {
    stroke-dasharray: 200, 200;
    stroke-dashoffset: -100;
  }
`;

const checkmarkAppear = keyframes`
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const StyledGenerateButton = styled.button`
  width: 100%;
  min-height: 60px; /* Stała wysokość */
  padding: 15px;
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  color: white;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
  /* Tekst zawsze w tym samym miejscu */
  .button-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    white-space: nowrap;
  }

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const GenerateButton = ({ children, tokenCost, ...props }) => {
  return (
    <StyledGenerateButton {...props}>
      {children}
      {tokenCost > 0 && (
        <TokenCostDisplay>
          <FaCoins /> {tokenCost}
        </TokenCostDisplay>
      )}
    </StyledGenerateButton>
  );
};

// Stały kontener dla statusu/błędów
export const StatusContainer = styled.div`
  min-height: 80px; /* Stała wysokość */
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProgressContainer = styled.div`
  text-align: center;
  padding: 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  width: 100%;
`;

export const ErrorMessage = styled.div`
  background: rgba(255, 0, 0, 0.2);
  border: 1px solid rgba(255, 0, 0, 0.5);
  padding: 15px;
  border-radius: 8px;
  color: #ffcccc;
  font-weight: 500;
  width: 100%;
`;

export const MusicSuccess = styled.div`
  background: rgba(76, 175, 80, 0.2);
  border: 1px solid rgba(76, 175, 80, 0.5);
  padding: 15px;
  border-radius: 8px;
  color: #c8e6c9;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  width: 100%;
`;

// Pozostałe komponenty - bez zmian z oryginalnego kodu
export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

// Zmodyfikowany Label z obsługą disabled
export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.color.spotifyWhite}; /* Domyślny kolor */
  transition: color 0.3s ease;
  
  /* Gdy sąsiaduje z disabled inputem/textarea */
  &:has(+ input:disabled),
  &:has(+ textarea:disabled) {
    color: rgba(255, 255, 255, 0.4); /* Szary kolor dla disabled */
  }
`;

// Nowy komponent dla tekstu "(nieaktywne)"
export const DisabledIndicator = styled.span`
  color: #cd5c5c; /* Niezbyt jaskrawy czerwony */
  font-size: 12px;
  font-weight: 400;
  margin-left: 8px;
  opacity: 0.8;
`;

// Kontener dla label i wskaźnika disabled
export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

// Zmodyfikowany Label dla kontenera
export const LabelText = styled.span`
  font-weight: 600;
  font-size: 16px;
  color: ${({ disabled, theme }) => 
    disabled 
      ? 'rgba(255, 255, 255, 0.4)' 
      : theme.color.spotifyWhite
  };
  transition: color 0.3s ease;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  box-sizing: border-box;
  transition: all 0.3s ease;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }
  
  &:focus {
    outline: none;
    background: rgba(255, 255, 255, 0.15);
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.2);
  }
  
  /* Style dla disabled */
  &:disabled {
    background: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.4);
    cursor: not-allowed;
    
    &::placeholder {
      color: rgba(255, 255, 255, 0.3);
    }
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  min-height: 100px;
  resize: vertical;
  box-sizing: border-box;
  font-family: inherit;
  transition: all 0.3s ease;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }
  
  &:focus {
    outline: none;
    background: rgba(255, 255, 255, 0.15);
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.2);
  }
  
  /* Style dla disabled */
  &:disabled {
    background: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.4);
    cursor: not-allowed;
    
    &::placeholder {
      color: rgba(255, 255, 255, 0.3);
    }
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  box-sizing: border-box;
  &:focus {
    outline: none;
    background: rgba(255, 255, 255, 0.15);
  }
  option {
    background: rgb(82, 82, 82);
    color: white;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

// export const Checkbox = styled.input`
//   width: 20px;
//   height: 20px;
//   cursor: pointer;
// `;
export const Checkbox = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  position: relative;
  transition: all 0.3s ease;

  /* Hover effect */
  &:hover {
    border-color: ${({ theme }) => theme.color.spotifyDarkGreen};
    background: rgba(255, 255, 255, 0.15);
  }

  /* Checked state - zielone tło */
  &:checked {
    background: ${({ theme }) => theme.color.spotifyDarkGreen};
    border-color: ${({ theme }) => theme.color.spotifyDarkGreen};
  }

  /* Checkmark - biały ptaszek */
  &:checked::before {
    content: "✓";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 14px;
    font-weight: bold;
  }
`;

export const HelpText = styled.div`
  font-size: 14px;
  opacity: 0.8;
  margin-top: 5px;
  padding: 8px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  border-left: 3px solid rgba(255, 255, 255, 0.3);
`;

export const ProgressText = styled.div`
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 500;
`;

export const LoadingSpinner = styled.div`
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const MusicPlayerContainer = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 20px;
  margin: 20px 0;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
`;

export const MusicPlayerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

export const MusicTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  flex: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const CloseButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
  }
`;

export const AudioControls = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
`;

export const PlayButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  color: white;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.05);
  }
`;

export const ProgressBarContainer = styled.div`
  flex: 1;
  cursor: pointer;
`;

export const ProgressBar = styled.div`
  height: 6px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 5px;
`;

export const ProgressFill = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #ff6b6b, #4ecdc4);
  border-radius: 3px;
  transition: width 0.1s ease;
`;

export const TimeDisplay = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
`;

export const ModeSection = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 20px;
//   margin: 20px 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const SectionTitle = styled.h3`
  margin: 0 0 15px 0;
  font-size: 18px;
  color: ${({ theme }) => theme.color.white};
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  position: relative;
  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, #1db954 0%, rgba(29, 185, 84, 0) 100%);
    border-radius: 3px;
  }
`;

export const DownloadButtonContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const DownloadButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: 8px 12px;
  color: white;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center; /* Wyśrodkuj zawartość */
  gap: 5px;
  cursor: pointer;
  
  /* DODANE: Stała szerokość */
  min-width: 11vh; /* Minimalna szerokość */
  width: 11vh; /* Stała szerokość */
 
  
  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
  
  /* Stan disabled podczas pobierania */
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
export const SuccessCheckmark = styled.div`
  width: 24px;
  height: 24px;
  position: absolute;
  top: 50%;
  left: calc(100% + 8px);
  transform: translateY(-50%);
  z-index: 1;
  .loading-circle {
    width: 24px;
    height: 24px;
    animation: ${loadingSpinner} 1s linear infinite;
  }
  .loading-circle circle {
    fill: none;
    stroke: #4caf50;
    stroke-width: 2;
    stroke-linecap: round;
    animation: ${circleComplete} 1.5s ease-in-out forwards;
  }
  .checkmark {
    position: absolute;
    top: 20%;
    left: 40%;
    transform: translate(-50%, -50%);
    color: #4caf50;
    font-size: 14px;
    font-weight: bold;
    opacity: 0;
    animation: ${checkmarkAppear} 0.3s ease-in-out 1.2s forwards;
  }
  @media (max-width: 768px) {
    width: 20px;
    height: 20px;
    left: calc(100% + 6px);
    .loading-circle {
      width: 20px;
      height: 20px;
    }
    .checkmark {
      font-size: 12px;
    }
  }
`;